// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"308fbfad","629":"ad23dc35","757":"5c2fd9df"}[chunkId] + ".chunk.css";
};